export default __webpack_public_path__ + "static/media/docusign_logo_white_text_on_black.0431b543.png";